module.exports = __webpack_public_path__ + "img/security2.ea4bf5ac.png";